<!-- pdf 预览 -->
<template>
    <el-dialog class="pdfPreview" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body :visible.sync="dialogVisible" width="50%">
        <div class="content" v-loading="loading">
            <pdf v-for="item in pageCount" :key="item" :src="pdfMsg.fullfileurl" :page="item" />
            <img :src="require('@/assets/measAssets/image/common/close.png')" @click="cancel" class="close" alt="">
        </div>
    </el-dialog>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  data() {
    return {
      dialogVisible: false,
      pageCount: 0,
      pdfMsg: {
        fullfileurl: '',
        previewimagelist: []
      },
      loading: false
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    open(url) {
      this.dialogVisible = true
      this.loading = true
      this.pdfMsg.fullfileurl = pdf.createLoadingTask(url)
      this.pdfMsg.fullfileurl.promise.then(pdf => {
        this.pageCount = pdf.numPages
        this.loading = false
      })
    },
    cancel() {
      this.dialogVisible = false
      this.pdfMsg = {
        fullfileurl: '',
        previewimagelist: []
      }
      this.pageCount = 0
      this.loading = false
    }
  },
  components: {
    pdf
  }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.pdfPreview {
  .el-dialog {
    background: transparent;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      border: none;
      background: transparent;
      .content {
        position: relative;
        min-height: 500px;
        background: transparent;
        .close {
          width: 20px;
          height: 20px;
          color: #4b5660;
          position: absolute;
          right: -10px;
          top: -10px;
          cursor: pointer;
          z-index: 10000;
        }
        .el-loading-spinner {
          top: 100px;
        }
      }
    }
  }
}
</style>